/* eslint-disable better-mutation/no-mutation */

import { component } from 'flightjs';

function WindowScroll() {
    let timer;

    this._onScroll = function () {
        if (!timer) {
            // Srolling has started
            this.trigger(document, 'utils:window-scroll:on-start');
        }

        clearTimeout(timer);
        timer = setTimeout(
            function () {
                // Scrolling has ended
                this.trigger(document, 'utils:window-scroll:on-stop');
                timer = undefined;
            }.bind(this),
            200
        );
    };

    this.after('initialize', function () {
        this.on('scroll', this._onScroll);
    });
}

export default component(WindowScroll);
